import { render, staticRenderFns } from "./Honebao.vue?vue&type=template&id=5b8c9662&"
import script from "./Honebao.vue?vue&type=script&lang=js&"
export * from "./Honebao.vue?vue&type=script&lang=js&"
import style0 from "./Honebao.vue?vue&type=style&index=0&id=5b8c9662&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports